// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"usersPage_wrapper__tvnIP","content":"usersPage_content__1Hy5G","sidebar":"usersPage_sidebar__1_SW7"};